module.exports = __webpack_public_path__ + "static/media/marc-bates.361829ef.jpg";